
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 450"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 450h900V0H0z","fill":"#d62828"}}),_c('path',{attrs:{"d":"M0 450V0h600z","fill":"#fcd856"}}),_c('path',{attrs:{"d":"M0 450V0h300z","fill":"#003f87"}}),_c('path',{attrs:{"d":"M0 450h900V150z","fill":"#fff"}}),_c('path',{attrs:{"d":"M0 450h900V300z","fill":"#007a3d"}})])
          )
        }
      }
    